module.exports = __webpack_public_path__ + "static/media/airconditioner_dry.ca84ecd8.png";